// extracted by mini-css-extract-plugin
module.exports = {"categories":"MainFilter_categories__JUojq"};